module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/headless-html/headless-html.component.css
// module id = ./src/app/examples/headless-html/headless-html.component.css
// module chunks = main